import { Box, SxProps, Typography } from "@mui/material";
import { OrderRowCounterContainer } from "./styles";

type Props = {
  orderRowCount: number;
  size?: number;
  sx: {
    boxSxProps: SxProps;
    textSxProps: SxProps;
  };
};

const OrderRowCounter = ({ orderRowCount, sx, size = 70 }: Props) => {
  return (
    <OrderRowCounterContainer size={size}>
      <Box sx={sx.boxSxProps}>
        {!!orderRowCount && (
          <Typography variant="header" sx={sx.textSxProps}>
            {orderRowCount}
          </Typography>
        )}
      </Box>
    </OrderRowCounterContainer>
  );
};

export default OrderRowCounter;
